import { render, staticRenderFns } from "./SimpleHouseList.vue?vue&type=template&id=6661a42d"
import script from "./SimpleHouseList.vue?vue&type=script&lang=js"
export * from "./SimpleHouseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports